import React from "react";
import YouTube from 'react-youtube';
import ReactPlayer from 'react-player/vimeo'
import { observer, inject } from "mobx-react";
import { observable } from "mobx";

@inject("store")
@observer

export default class DocTypeScriptAndHtmlInjection extends React.Component {
    constructor(props) {
        super(props);
        //this.ref = Math.random().toString(36).substr(2, 9);
    }

    render() {
        var content = this.props.model.content;
        return (<div dangerouslySetInnerHTML={{ __html: content }}></div> );
    }
}